export default __webpack_public_path__ + "static/media/bottom_trees.f664e253.svg";